/**
 * Created by IMRANEXPT on 1/24/16.
 */
(function() {
    /** @ngInject */
    function giftCardproductsPageController($scope, $state,$document,$timeout,$http){
        var giftcard = _.parseInt($scope.booking.meal.type) === 8;
        $scope.products = [];
        var productSelected = false;
        function initProducts(){
            $scope.booking.getProducts().then(function(){
                $scope.products = $scope.booking.products;
                var selected = _.find($scope.products, {global : true});
                if(selected) {$scope.selectProduct(selected);}else{
                    $scope.selectProduct(_.first($scope.products));
                }
            });
        }
        $scope.$on("$viewContentLoaded", function() {
            initProducts();
        });
        $scope.isSelectedProduct = function(product){
            $scope.booking.giftcard.product && product.id === $scope.booking.giftcard.product.id;
        };
        $scope.selectProduct = function(product){
            $scope.booking.giftcard.product = angular.copy(product);
            //productSelected = true;
        };
        $scope.incProduct = function(product, e){
            if(e) e.stopPropagation();
            productSelected = false;
            //product.price += 100;
            product.price = Math.ceil((product.price+1) / 100) * 100;
            if(product.price > $scope.booking.giftcard.max_value)
                product.price = _.parseInt($scope.booking.giftcard.max_value);
            $scope.booking.giftcard.product = angular.copy(product);
        };
        $scope.decProduct = function(product, e){
            if(e) e.stopPropagation();
            productSelected = false;
            if((product.price-10) < 0) return false;
            product.price = Math.floor((product.price - 1) / 100) * 100;
            if(product.price < $scope.booking.giftcard.min_value)
                product.price = _.parseInt($scope.booking.giftcard.min_value);
            $scope.booking.giftcard.product = angular.copy(product);
        };
        $scope.selectedProducts = function(page){
            return productSelected;
        };
        $scope.decAmount = function(){
          $scope.booking.giftcard.amount -= 1;
          if($scope.booking.giftcard.amount < 1) $scope.booking.giftcard.amount = 1;
        };
        $scope.getEquallyMarginedNumbers = function() {
            var min = _.parseInt($scope.booking.giftcard.min_value);
            var max = _.parseInt($scope.booking.giftcard.max_value);
            if (!_.isNumber(min) || !_.isNumber(max) || min >= max) {
                return [];
            }
            let step;
            if (max <= 2000) {
                step = 500;
            } else if (max <= 4000) {
                step = 1000;
            } else if (max <= 10000) {
                step = 2000;
            } else {
                step = 5000;
            }
            let presets = [];
            for (let i = step; i <= max; i += step) {
                if (i >= min) {
                    presets.push(i);
                }
            }

            return presets.length > 0 ? presets : [];

        };
        $scope.incAmount = function(){
            $scope.booking.giftcard.amount += 1;
            if($scope.booking.giftcard.amount > 100) $scope.booking.giftcard.amount = 100;
        };
        $scope.setProductPrice = function(product, price){
            productSelected = false;
            product.price = price;
            $scope.booking.giftcard.product = angular.copy(product);
        };
        $scope.next = function(){
            if(!productSelected && $scope.booking.giftcard.product){
                productSelected = true;
            }else{
                $scope.booking.booking_products.push({
                    ID : $scope.booking.giftcard.product.id,
                    meal_name : $scope.booking.giftcard.product.name,
                    meal_price : $scope.booking.giftcard.product.price,
                    amount : $scope.booking.giftcard.amount,
                });
                $state.go('confirm', {}, {location: false});
            }
        };
    }
    angular.module("Waiteraid").controller("giftcardProductsCtrl", giftCardproductsPageController);
})();
